/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CSSProperties } from "react";
import { css, cx } from "@panda/css";
import { Box, BoxProps } from "@panda/jsx";
import { useMaxWidth } from "@components/utils/section.utils";

const responsiveContainer = css({
	position: "relative",
	width: "100%",
	maxWidth: "var(--responsive-container-max-width, 1440px)",
	marginInline: "auto",
});

export interface ResponsiveContainerProps extends BoxProps {
	disable?: boolean;
	children?: React.ReactNode;
	className?: string;
	maxWidth?: string;
}

export interface ResponsiveContainerCssVariables extends CSSProperties {
	"--responsive-container-max-width"?: string;
}

export const ResponsiveContainer = ({
	disable,
	className = "",
	children,
	maxWidth: maxWidthProp,
	...rest
}: ResponsiveContainerProps): React.ReactNode => {
	const effectiveMaxWidth = useMaxWidth(maxWidthProp);

	if (disable) {
		return children;
	}

	const styleVars: ResponsiveContainerCssVariables = {
		"--responsive-container-max-width": effectiveMaxWidth,
	};

	return (
		<Box className={cx("responsive-container", responsiveContainer, className)} style={styleVars} {...rest}>
			{children}
		</Box>
	);
};
